import { createFileRoute } from '@tanstack/react-router';

import { bankAccountDetailScreen, bankAccountDetailSearch, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Detalhe da conta (`router.tsx:395-485`); as abas do legado viram `?tab=`.
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/')({
  validateSearch: bankAccountDetailSearch,
  staticData: { screen: bankAccountDetailScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountDetailScreen'),
});
